import * as React from "react";
const SvgIcPlayFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 2L22 12L6 22V2Z" fill="currentColor" /></svg>;
export default SvgIcPlayFilled;